// This enum is needed in roles-guard.service.ts to know if the route is only for users.
// It's provided to the guards by the route data property in routing modules.
export enum ModuleNameEnum {
  dashboard = 'dashboard'
}
